// src/pages/Home.tsx
import React, { useEffect, useState } from "react";
import styles from "../styles/Home.module.css";

interface Review {
  id: number;
  name: string;
  vehicle: string;
  review: string;
  imagePath?: string | null;
  createdAt: string;
}

// Backend URL from .env
const API_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5001";
console.log(API_URL)

const Home: React.FC = () => {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const res = await fetch(`${API_URL}/reviews`);
        const data: Review[] = await res.json();
        setReviews(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchReviews();
  }, []);

  return (
    <div className={styles.home}>
      {/* Hero Section */}
      <section
        className={styles.hero}
        style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/car-hero.jpg)` }}
      >
        <div className={styles.overlay}>
          <h1>Drive Your Dream Car</h1>
          <p>We import quality vehicles to Uganda with full transparency.</p>
          <a href="/contact" className={styles.ctaBtn}>
            Get a Quote
          </a>
        </div>
      </section>

      {/* Services Section */}
      <section
        className={styles.services}
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/background2.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "scroll",
        }}
      >
        <h2>OUR SERVICES</h2>
        <div className={styles.serviceCards}>
          <div className={styles.card}>
            <img src={`${process.env.PUBLIC_URL}/car-service.jpg`} alt="Import Assistance" />
            <div>
              <h3>IMPORT ASSISTANCE</h3>
              <p>We handle sourcing and import logistics for your vehicle.</p>
            </div>
          </div>

          <div className={styles.card}>
            <img src={`${process.env.PUBLIC_URL}/inspection.jpg`} alt="Vehicle Inspection" />
            <div>
              <h3>VEHICLE INSPECTION</h3>
              <p>Thorough inspection reports for complete peace of mind.</p>
            </div>
          </div>

          <div className={styles.card}>
            <img src={`${process.env.PUBLIC_URL}/clearance.jpg`} alt="Clearance and Delivery" />
            <div>
              <h3>CLEARANCE & DELIVERY</h3>
              <p>Customs clearance and doorstep delivery within Uganda.</p>
            </div>
          </div>

          <div className={styles.card}>
            <img src={`${process.env.PUBLIC_URL}/consultation.jpg`} alt="Consultation" />
            <div>
              <h3>CONSULTATION</h3>
              <p>Expert advice on vehicle selection, pricing, and registration.</p>
            </div>
          </div>
        </div>

        <div className={styles.ctaSection}>
          <h2>Ready to Import Your Car?</h2>
          <a href="/contact" className={styles.ctaBtn}>
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Latest Reviews Carousel */}
      <section className={styles.reviews}>
        <h2>What Our Clients Say</h2>
        <div className={styles.carousel}>
          {reviews.length === 0 && <p>Loading reviews...</p>}
          {reviews.map((rev) => (
            <div key={rev.id} className={styles.reviewCard}>
              {rev.imagePath && (
                <img src={`${API_URL}${rev.imagePath}`} alt={rev.vehicle} />
              )}
              <h4>{rev.name}</h4>
              <p><strong>{rev.vehicle}</strong></p>
              <p>"{rev.review}"</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;
